<template>
  <v-switch
    :loading="loading"
    inset
    :input-value="!!transaction.verified_at"
    @change="toggleVerification"
    :disabled="loading"
    :color="!!transaction.verified_at ? 'primary' : ''"
  ></v-switch>
</template>
<script>
export default {
  props: { dataTransaction: { required: true } },
  data() {
    return { transaction: this.dataTransaction, loading: false };
  },
  methods: {
    toggleVerification(value) {
      this.loading = true;
      this.$http
        .put(`api/v1/cryptoTransactions/${this.transaction.id}/verify`, {
          value,
        })
        .then(({ transaction }) => {
          this.transaction = transaction;
          this.$emit("updated", transaction);
        })
        .catch(this.showResponseError)
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
